const mediaData = [
  {
    title: '「剑尊归来」名场面合集',
    desc: '回顾剑尊重生后的经典战斗场面，每一帧都是壁纸级别。',
    img: 'https://readdy.ai/api/search-image?query=Epic%20anime%20style%20action%20scene%20with%20swordsman%20in%20combat%20pose%2C%20dramatic%20lighting%20with%20glowing%20energy%20effects%2C%20cinematic%20composition%2C%20warm%20coral%20and%20golden%20color%20palette%2C%20clean%20background%20with%20motion%20blur%20effects%2C%20manga-inspired%20illustration%20style&width=800&height=450&seq=manga-media-01&orientation=landscape',
    tag: '热门剪辑',
  },
  {
    title: '韩漫推荐：那些年追过的神作',
    desc: '从经典到新番，韩漫爱好者的必读清单大公开。',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20collage%20style%20illustration%20of%20various%20Korean%20manhwa%20characters%20in%20different%20art%20styles%2C%20colorful%20and%20vibrant%20composition%2C%20warm%20lighting%20with%20soft%20gradients%2C%20clean%20modern%20layout%2C%20editorial%20design%20aesthetic&width=800&height=450&seq=manga-media-02&orientation=landscape',
    tag: '推荐合集',
  },
  {
    title: '国漫崛起：从狐妖到全职高手',
    desc: '盘点近年来最值得关注的国产漫画作品，见证国漫力量。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20illustration%20with%20traditional%20eastern%20aesthetic%2C%20beautiful%20characters%20in%20flowing%20robes%20with%20magical%20elements%2C%20ink%20wash%20painting%20style%20mixed%20with%20modern%20anime%2C%20warm%20golden%20and%20vermilion%20tones%2C%20elegant%20composition%20with%20clouds%20and%20mountains&width=800&height=450&seq=manga-media-03&orientation=landscape',
    tag: '专题策划',
  },
  {
    title: '日漫经典永不过时',
    desc: '那些陪伴一代人成长的日漫神作，值得我们反复重温。',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20with%20diverse%20characters%20showing%20different%20emotions%2C%20school%20life%20and%20adventure%20themes%2C%20bright%20and%20cheerful%20color%20palette%2C%20clean%20linework%20with%20expressive%20faces%2C%20warm%20and%20inviting%20atmosphere&width=800&height=450&seq=manga-media-04&orientation=landscape',
    tag: '经典回顾',
  },
  {
    title: '甜到炸的恋爱漫画推荐',
    desc: '精选那些让人心跳加速的浪漫恋爱漫，每部都甜度满分。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20shojo%20manga%20illustration%20with%20couple%20under%20cherry%20blossom%20tree%2C%20soft%20pink%20and%20peach%20color%20scheme%2C%20floating%20petals%20and%20sparkles%2C%20gentle%20warm%20lighting%2C%20dreamy%20atmosphere%2C%20delicate%20linework%20style&width=800&height=450&seq=manga-media-05&orientation=landscape',
    tag: '甜漫精选',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-2">精彩专题</h2>
          <p className="text-sm text-foreground-500">深度解读热门作品，发现更多好看的漫画</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaData.map((item, i) => (
            <a
              key={i}
              href="#media"
              onClick={(e) => e.preventDefault()}
              className={`group block rounded-xl overflow-hidden bg-background-50 no-underline ${
                i === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className={`relative bg-background-200 ${
                i === 0 ? 'aspect-[16/7]' : 'aspect-[16/10]'
              }`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] px-2 py-0.5 rounded-full bg-primary-500/90 text-background-50 font-medium">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 to-transparent pointer-events-none"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-sm md:text-base font-bold text-background-50 mb-1">{item.title}</h3>
                  <p className="text-xs text-background-50/80">{item.desc}</p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}